import { render, staticRenderFns } from "./RewardsBeforeAuth.vue?vue&type=template&id=afb3b3f0&scoped=true"
import script from "./RewardsBeforeAuth.vue?vue&type=script&lang=js"
export * from "./RewardsBeforeAuth.vue?vue&type=script&lang=js"
import style0 from "./RewardsBeforeAuth.vue?vue&type=style&index=0&id=afb3b3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb3b3f0",
  null
  
)

export default component.exports